import { ModificationReport } from "../../../../../core";
import { ModificationType } from "../../../../../core/configs/report.config";

export const modificationReport = {
    searchText: '',
    sort: true,
    dialogHability: true,
    filter: false,
    paginator: true,
    checkbox: false,
    export: true,
    exportAllData: true,
    exportNameAdditional: 'reporte modificaciones',
    exportFile: 'reporte_modificaciones.xlsx',
    expandable: false,
    disabled: false,
    partialField: '',
    columns: [
      {
        title: 'N° de nota de venta',
        name: 'orderNumber',
        type: 'string',
        class: 'center',
        value: (element: ModificationReport) => element.orderNumber
      },
      {
        title: 'N° Cotización',
        name: 'quotationNumber',
        type: 'string',
        class: 'center',
        value: (element: ModificationReport) => element.quotationNumber
      },
      {
        title: 'N° Despacho',
        name: 'dispatchNumber',
        type: 'string',
        class: 'center',
        value: (element: ModificationReport) => element.dispatchNumber
      },
      {
        title: 'SKU',
        name: 'sku',
        type: 'string',
        class: 'left',
        value: (element: ModificationReport) => element.sku
      },
      {
        title: 'Sucursal de venta',
        name: 'entityName',
        type: 'string',
        class: 'center',
        value: (element: ModificationReport) => element.saleEntity
      },
      {
        title: 'Usuario de creación de N/V',
        name: 'creationUser',
        type: 'string',
        class: 'center',
        value: (element: ModificationReport) => element.createdBy
      },
       {
        title: 'Usuario de modificación de N/V',
        name: 'modificationUser',
        type: 'string',
        class: 'center',
        value: (element: ModificationReport) => element.updatedBy
      },
      {
        title: 'Role/s del usuario de modificación',
        name: 'roles',
        type: 'string',
        class: 'center',
        value: (element: ModificationReport) => {
          return element.roles ? element.roles.replace('[', '').replace(']', '') : ''
         }
      },
      {
        title: 'Tipo de modificación',
        name: 'modificationType',
        type: 'string',
        class: 'center',
        value: (element: ModificationReport) => ModificationType[element.authorizationType]
      },
      {
        title: 'Fecha de creación de N/V',
        name: 'creationDate',
        type: 'string',
        class: 'center',
        value: (element: ModificationReport) => element.creationDate
      },
      {
        title: 'Fecha de modificación de N/V',
        name: 'modificationDate',
        type: 'string',
        class: 'center',
        value: (element: ModificationReport) => element.updateDate
      },
      {
        title: 'Valor inicial',
        name: 'initialValue',
        type: 'string',
        class: 'center',
        value: (element: ModificationReport) => element.previousValue
      },
      {
        title: 'Valor modificado',
        name: 'deliveryQuantity',
        type: 'string',
        class: 'center',
        value: (element: ModificationReport) => element.currentValue
      },
      {
        title: 'Nombre y Apellido del cliente',
        name: 'customerName',
        type: 'string',
        class: 'left',
        value: (element: ModificationReport) => element.customerName + ' ' + element.customerLastName
      },
      {
        title: 'Teléfono del cliente',
        name: 'contactPhone',
        type: 'string',
        class: 'left',
        value: (element: ModificationReport) => element.contactPhone
      },
      {
        title: 'Correo del cliente',
        name: 'contactEmail',
        type: 'string',
        class: 'left',
        value: (element: ModificationReport) => element.contactEmail
      },
      {
        title: 'Usuario autorizador',
        name: 'authorizedUser',
        type: 'string',
        class: 'left',
        value: (element: ModificationReport) => element.authorizedUser ? element.authorizedUser : ""
      },
      {
        title: 'Observaciones',
        name: 'observations',
        type: 'button',
        editable: false,
        checkAll: false,
        class: 'center',
        value: (element: ModificationReport) => {
          return {
            data: [element.observations],
            icon: 'search',
            tooltip: 'Mostrar observaciones',
            class: ' recordColumn icon-table',
            disabled: element.observations ? false : true
          };
        }
      }
    ]
  }
